import { useAssistantUiState } from './uiActions/assistantUiContext';

export function AssistantLiveRegion() {
  const { announcement } = useAssistantUiState();
  return (
    <div className="sr-only" aria-live="polite">
      {announcement}
    </div>
  );
}
